// Copyright (c) 2024. Heusala Group Oy <info@heusalagroup.fi>. All rights reserved.

import { useCookieConsent } from "../../../../../../io/hyperify/frontend/hooks/useCookieConsent";
import { CookieConsent } from "../../../../../../io/hyperify/frontend/types/CookieConsent";

export interface FacebookPixelProps {
    readonly url : string;
}

export function FacebookPixel (props: FacebookPixelProps) {
    const [ cookieConsent ] = useCookieConsent();
    if (cookieConsent === CookieConsent.ACCEPT_ALL) {
        return (
            <img alt="" src={props.url} height="1" width="1" style={ { display : "none" } }/>
        );
    }
    return null;
}
